import { useNavigate } from "react-router-dom";
import { usePlan } from "@/context/PlanContext";
import { Sparkles, Crown } from "lucide-react";

export default function PlanBadge() {
  const { plan, isPro } = usePlan();
  const navigate = useNavigate();
  if (!plan) return null;

  if (isPro) {
    return (
      <button
        data-testid="plan-badge-pro"
        onClick={() => navigate("/pricing")}
        className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest font-bold px-2.5 py-1 rounded-full transition-transform hover:-translate-y-0.5"
        style={{ background: "linear-gradient(135deg,#D96B43,#BF5832)", color: "white" }}
        title="Manage Harmonix Pro"
      >
        <Crown size={11} /> Pro
      </button>
    );
  }

  return (
    <button
      data-testid="plan-badge-upgrade"
      onClick={() => navigate("/pricing")}
      className="inline-flex items-center gap-1.5 text-[11px] font-semibold px-3 py-1.5 rounded-full border transition-colors hover:bg-[#F4EFE6]"
      style={{ borderColor: "#E5DEC9", color: "#1C2826", background: "#FFFFFF" }}
      title="Upgrade to Pro"
    >
      <Sparkles size={12} style={{ color: "#D96B43" }} /> Upgrade
    </button>
  );
}
